/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable jsx-a11y/media-has-caption */
/* eslint-disable react/button-has-type */
import { CloseOutlined } from "@ant-design/icons";
import { Image, Tooltip } from "antd";
import React, { useEffect, useMemo, useState } from "react";
import DocumentIcon from "../../../icons/js/DocumentIcon";
import { formatBytes } from "../../../library/utils";
import MediaPreview from "../../commonComponents/MediaPreview";
import MediaPreviewTrigger from "../../commonComponents/MediaPreviewTrigger";
import { buildAttachmentItems } from "./mediaSharing/mediaPreviewItems";

const Attachments = ({ attachments, setAttachments }) => {
  const [activekey, setactivekey] = useState(1);
  // Slide the shared previewer opens on; null = closed.
  const [previewIndex, setPreviewIndex] = useState(null);

  // One slide per attachment, in the same order as the row, so a tile's position
  // is its slide index.
  const previewItems = useMemo(() => buildAttachmentItems(attachments), [attachments]);

  const handleDeleteAttachment = index => {
    const updatedAttachments = [...attachments];
    const removedAttachment = updatedAttachments[index];
    // Clean up blob URL to prevent memory leaks
    if (removedAttachment?.preview && removedAttachment.preview.startsWith("blob:")) {
      URL.revokeObjectURL(removedAttachment.preview);
    }
    updatedAttachments.splice(index, 1);
    setAttachments(updatedAttachments);
  };
  useEffect(() => {
    setactivekey(1);
  }, [attachments]);
  return (
    <div>
      {attachments.length > 0 && (
        <div className="flex flex-row h-[100px] w-full items-center gap-2.5">
          {attachments.map((attachment, index) => {
            const size = formatBytes(attachment.file.size);
            return (
              <AttachmentRender
                key={index}
                index={index}
                attachment={attachment}
                onPreview={() => setPreviewIndex(index)}
                handleDeleteAttachment={handleDeleteAttachment}
                size={size}
              />
            );
          })}
        </div>
      )}
      {/* Shared previewer — replaces antd's PreviewGroup, the video modal and the
          PDF popup. Download is hidden: these files are local blobs that haven't
          been uploaded, and the user already has them. */}
      {previewIndex !== null && (
        <MediaPreview
          open
          items={previewItems}
          initialIndex={previewIndex}
          showDownload={false}
          onClose={() => setPreviewIndex(null)}
        />
      )}
    </div>
  );
};

export default Attachments;
function AttachmentRender({ index, attachment, onPreview, handleDeleteAttachment, size }) {
  const [showDelete, setshowDelete] = useState(false);
  return (
    <div
      className="flex flex-col w-fit"
      onMouseEnter={() => setshowDelete(true)}
      onMouseLeave={() => setshowDelete(false)}
      key={index}
    >
      <div className="inline-block w-full h-full relative rounded overflow-hidden">
        {attachment.file.type.includes("image") ? (
          <div className="p-2 rounded-lg border-solid border-[1px] border-grey-200">
            {/* preview={false} — antd's own lightbox (and its hover mask) is
                replaced by the shared MediaPreview + MediaPreviewTrigger. */}
            <MediaPreviewTrigger onPreview={onPreview}>
              <Image
                className="aspect-video object-contain cursor-pointer"
                src={attachment.preview}
                preview={false}
                width="80px"
                height="80px"
              />
            </MediaPreviewTrigger>
          </div>
        ) : attachment.file.type.includes("video") ? (
          <div className="p-2 rounded-lg border-solid border-[1px] border-grey-200">
            {/* No native controls on this tile, so the mask can cover it fully. */}
            <MediaPreviewTrigger onPreview={onPreview}>
              <video
                style={{
                  width: "120px",
                  height: "80px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  backgroundColor: "#F0F0F0",
                  cursor: "pointer",
                }}
              >
                <source src={attachment.preview} type="video/mp4" />
              </video>
            </MediaPreviewTrigger>
          </div>
        ) : (
          <MediaPreviewTrigger
            onPreview={onPreview}
            radiusClassName="rounded-lg"
            className="p-2 h-[100px] border-[1px] border-solid border-grey-200"
          >
            <span className="flex-col-centered h-full gap-1.5 items-center justify-center rounded-[4px] bg-grey-100 p-2">
              <DocumentIcon />
              <Tooltip title={attachment.file.name}>
                <span className="ellipsis w-[60px]">{attachment.file.name}</span>
              </Tooltip>
            </span>
          </MediaPreviewTrigger>
        )}
        {showDelete && (
          <button
            className="absolute top-[5px] right-[5px] z-[1] p-0.5 bg-slate-600 text-white rounded-full w-5 h-5 flex justify-center items-center cursor-pointer border-none "
            onClick={e => {
              e.stopPropagation();
              handleDeleteAttachment(index);
            }}
          >
            <CloseOutlined />
          </button>
        )}
      </div>
      <span className="text-sm flex flex-row items-center gap-1 justify-center font-[500]">
        {size}
      </span>
    </div>
  );
}
